import React from 'react';
import { Award, Gem, Trophy, Star } from 'lucide-react';

// Demo veriler
const users = [
  { id: 1, name: 'Emre Çelik', avatar: 'https://placehold.co/100x100/A0E7E5/ffffff?text=EÇ', badges: 58, points: 2540 },
  { id: 2, name: 'Ayşe Yılmaz', avatar: 'https://placehold.co/100x100/F4C5A0/ffffff?text=AY', badges: 52, points: 2210 },
  { id: 3, name: 'Mehmet Kaya', avatar: 'https://placehold.co/100x100/B8A2C7/ffffff?text=MK', badges: 45, points: 1980 },
  { id: 4, name: 'Elif Şahin', avatar: 'https://placehold.co/100x100/D9A7C7/ffffff?text=EŞ', badges: 41, points: 1750 },
  { id: 5, name: 'Caner Aksoy', avatar: 'https://placehold.co/100x100/B2D8D8/ffffff?text=CA', badges: 39, points: 1630 },
  { id: 6, name: 'Pınar Turan', avatar: 'https://placehold.co/100x100/F5CBA7/ffffff?text=PT', badges: 35, points: 1510 },
  { id: 7, name: 'Ahmet Arslan', avatar: 'https://placehold.co/100x100/C4D7B2/ffffff?text=AA', badges: 31, points: 1390 },
  { id: 8, name: 'Gamze Demir', avatar: 'https://placehold.co/100x100/B0C4DE/ffffff?text=GD', badges: 28, points: 1270 },
  { id: 9, name: 'Kaan Vural', avatar: 'https://placehold.co/100x100/E8D9E8/ffffff?text=KV', badges: 25, points: 1150 },
  { id: 10, name: 'Gizem Can', avatar: 'https://placehold.co/100x100/A0CED9/ffffff?text=GC', badges: 23, points: 1030 },
];

const getRankClass = (index) => {
  if (index === 0) return { icon: <Trophy className="text-yellow-400 fill-yellow-400" size={24} />, card: 'bg-gray-700 shadow-lg border-2 border-yellow-400' };
  if (index === 1) return { icon: <Trophy className="text-gray-400 fill-gray-400" size={24} />, card: 'bg-gray-700 shadow-lg border-2 border-gray-400' };
  if (index === 2) return { icon: <Trophy className="text-amber-700 fill-amber-700" size={24} />, card: 'bg-gray-700 shadow-lg border-2 border-amber-700' };
  return { icon: <Star className="text-gray-400" size={20} />, card: 'bg-gray-800' };
};

const RankingPage = () => {
  return (
    <div className="bg-gray-900 min-h-screen p-4 sm:p-6 lg:p-8 font-sans text-gray-100">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl md:text-6xl mb-8 sm:mb-12 text-center font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500 drop-shadow-xl animate-fade-in">
            Liderlik Tablosu
        </h1>

        <div className="space-y-4">
          {users.map((user, index) => {
            const rankInfo = getRankClass(index);
            return (
              <div
                key={user.id}
                className={`flex items-center p-4 rounded-xl transition-all duration-300 transform hover:scale-[1.01] ${rankInfo.card}`}
              >
                <div className="w-10 text-center font-bold text-gray-400 text-lg mr-4 flex-shrink-0">
                  <span className="w-8 h-8 rounded-full flex items-center justify-center bg-gray-600 text-sm font-medium">{index + 1}</span>
                </div>
                
                <div className="flex items-center flex-grow">
                  <div className="w-12 h-12 rounded-full overflow-hidden mr-4 border-2 border-gray-500">
                    <img src={user.avatar} alt={user.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="flex flex-col flex-grow">
                    <span className="font-semibold text-lg text-gray-50">{user.name}</span>
                    <div className="flex items-center mt-1 text-gray-400 text-sm">
                      <Award size={16} className="text-pink-400 mr-1" />
                      <span>{user.badges} Rozet</span>
                      <Gem size={16} className="text-sky-400 ml-3 mr-1" />
                      <span>{user.points} Puan</span>
                    </div>
                  </div>
                </div>

                <div className="flex-shrink-0 ml-4">
                  {rankInfo.icon}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RankingPage;
